export default "__VITE_ASSET__D$gcB6gc__"